var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "m3.8 7 2.9 2.9a.95.95 0 0 1 .276.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275L.7 6.7a.9.9 0 0 1-.213-.325A1.1 1.1 0 0 1 .426 6q0-.2.062-.375A.9.9 0 0 1 .701 5.3L5.3.7A.95.95 0 0 1 6 .425q.424 0 .7.275a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7L3.8 5H17q.424 0 .712.287.288.288.288.713 0 .424-.288.712a.97.97 0 0 1-.712.288z"
  })));
};
export default SvgArrowLeft;